import React from 'react';

import { Button } from '@edx/components/button';
import { Body, Title } from '@edx/components/typography';

type Props = {
  projectName: string;
  projectShortName: string;
  upsellUrl: string;
};

export const GiftBanner: React.FC<Props> = ({ projectName, projectShortName, upsellUrl }) => (
  <div className="border-2 border-white border-opacity-10 rounded flex flex-col sm:flex-row justify-between">
    <div className="flex w-full">
      <div className="-mt-2 pl-6 hidden md:flex flex-none">
        <img src="/img/pricing/banner_regala.png" alt="" />
      </div>

      <div>
        <div className="pl-6 pt-6 pb-0 sm:pb-6 pr-6 sm:pr-0">
          <Title size="small" className="text-white leading-tight">
            Regala {projectShortName}
          </Title>
          <Body tag="h4" className="text-gray-500">
            Regala a tus amigos una suscripción a {projectName}.
          </Body>
        </div>
      </div>
      <div className="p-6 hidden md:flex items-center ml-auto">
        <Button size="large" textVariant="medium" href={upsellUrl}>
          Regala {projectShortName}
        </Button>
      </div>
      <div className="p-6 flex md:hidden items-center ml-auto">
        <Button textVariant="medium" href={upsellUrl}>
          Regala {projectShortName}
        </Button>
      </div>
    </div>
  </div>
);
